import { PageHeader } from "procurement/design"

// Title + breadcrumb only. In-page ORDERS / PURCHASES / … tab strips duplicated
// the sidebar and are intentionally gone — sidebar + breadcrumb are the only
// navigation chrome.
const ManagerWorkspaceHeader = ({ title, breadcrumb, description }) => {
  const crumbs = ["Procurement"]
  if (breadcrumb && !/procurement/i.test(breadcrumb)) crumbs.push(breadcrumb)
  crumbs.push(title)

  return (
    <PageHeader
      breadcrumb={crumbs}
      title={title}
      subtitle={description}
    />
  )
}

export default ManagerWorkspaceHeader
